import ApolloClient from 'apollo-boost';
import { getAuthToken } from '../auth/Auth';


const SERVER_URL = 'https://api.bidft.auction/';
// const SERVER_URL = 'http://localhost:4000/graphql';
const client = new ApolloClient({
  uri: process.env.REACT_APP_GRAPHQL_URL || SERVER_URL,
  request: (operation) => {
    operation.setContext(context => ({
      headers: {
        ...context.headers,
        authorization: getAuthToken(),
      },
    }));
  },
});

export default client;



// WEBPACK FOOTER //
// ./src/client/index.js